"use client"

import { useEffect, useMemo, useState } from "react"
import { formatTime } from "../helpers"

interface Props {
    percentage: number
}

export function LoadingBar({ percentage }: Props) {
    const start = useMemo(() => Date.now(), [])
    const [eta, setEta] = useState<number>()

    useEffect(() => {
        if (percentage > 10) {
            const duration = Date.now() - start
            const pace = duration / percentage
            setEta(pace * (100 - percentage)) // Estimated time remaining in milliseconds
        }
    }, [start, percentage])

    return (
        <div>
            <div className="h-4 w-full rounded bg-gray-200">
                <div
                    className="bg-primary-500 h-full rounded transition-all duration-300"
                    style={{ width: `${percentage}%` }}
                ></div>
            </div>
            {eta !== undefined && (
                <div className="mt-2 text-sm text-gray-700">Estimated time remaining: {formatTime(eta / 1000)}</div>
            )}
        </div>
    )
}
